module.exports = __webpack_public_path__ + "media/images/Icon-reservation-done-16ccb9d083bccb0532e5171f26b7ab80.svg";